import React from "react";
import { motion } from "framer-motion";
import { Check, Building2, Info } from "lucide-react";
import { useLang } from "@/i18n";

export const Comparison = () => {
  const { t } = useLang();
  const c = t.compare;
  const rows = [
    ["reg", "regL", "regR", "regLLD", true],
    ["owner", "ownL", "ownR", "ownLLD", false],
    ["balance", "balL", "balR", "balLLD", false],
    ["residual", "resL", "resR", "resLLD", false],
    ["end", "endL", "endR", "endLLD", false],
  ];
  const cols = [
    { key: "leasing", label: c.col.leasing, accent: true },
    { key: "renting", label: c.col.renting, accent: false },
    { key: "lld", label: c.col.lld, accent: false },
  ];
  return (
    <section id="compare" className="relative py-24 sm:py-32 bg-[#0d2138] border-y border-white/5" data-testid="comparison">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <p className="text-xs uppercase tracking-[0.2em] text-accent mb-3">{c.col.crit}</p>
          <h2 className="font-display text-3xl sm:text-5xl font-bold">{c.title}</h2>
          <p className="mt-4 text-muted-foreground text-lg">{c.subtitle}</p>
        </div>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="overflow-x-auto rounded-2xl border border-white/10">
          <table className="w-full min-w-[680px] text-sm" data-testid="comparison-table">
            <thead>
              <tr className="border-b border-white/10">
                <th className="text-left p-5 font-medium text-muted-foreground w-1/4">{c.col.crit}</th>
                {cols.map((col) => (
                  <th key={col.key} className={`text-left p-5 font-display text-lg font-bold ${col.accent ? "text-accent" : "text-white"}`}>
                    <span className="flex items-center gap-2">{col.accent && <Building2 className="w-4 h-4" strokeWidth={1.5} />}{col.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map(([rowKey, l, r, lld, highlight], i) => (
                <tr key={rowKey} className={`border-b border-white/5 ${highlight ? "bg-accent/5" : "hover:bg-white/[0.02]"} transition-colors`} data-testid={`compare-row-${rowKey}`}>
                  <td className="p-5 font-medium text-white">{c.rows[rowKey]}{highlight && <Check className="inline w-3.5 h-3.5 ml-1.5 text-accent" strokeWidth={2.5} />}</td>
                  <td className={`p-5 ${highlight ? "text-accent font-semibold" : "text-muted-foreground"}`}>{c.vals[l]}</td>
                  <td className="p-5 text-muted-foreground">{c.vals[r]}</td>
                  <td className="p-5 text-muted-foreground">{c.vals[lld]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>

        <div className="mt-6 flex items-start gap-3 rounded-xl border border-accent/20 bg-accent/5 p-4">
          <Info className="w-5 h-5 text-accent shrink-0 mt-0.5" strokeWidth={1.5} />
          <p className="text-sm text-gray-300 leading-relaxed">{c.note}</p>
        </div>
      </div>
    </section>
  );
};
